import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getBank = createAsyncThunk(
  "admin/bank",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/bank", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getBankById = createAsyncThunk(
  "admin/bank/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/bank/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortBank = createAsyncThunk(
  "admin/bank/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/bank/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postBank = createAsyncThunk(
  "admin/bank/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/bank", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteBank = createAsyncThunk(
  "admin/bank/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/bank/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateBank = createAsyncThunk(
  "admin/bank/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/bank/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const bankSlice = createSlice({
  name: "Bank Store",
  initialState: initialState,
  reducers: {
    addBank(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortBank(state, action) {
      state.data.docs = action.payload;
    },
    deleteBank(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editBank(state, action) {
      let index = state.data.docs.findIndex(item => item._id === action.payload._id);
      state.data.docs[index] = action.payload;
   },
  },
  extraReducers: {
    [getBank.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getBank.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getBank.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getBankById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getBankById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getBankById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortBank.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortBank.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortBank.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postBank.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postBank.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postBank.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteBank.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteBank.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteBank.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateBank.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateBank.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateBank.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const bankActions = bankSlice.actions;

export default bankSlice.reducer;
